import { PureLightTheme } from "../../../../styles/theme";
import { COLORS } from "../../../../styles/variables";

export const CardStyle = {
    padding: "24px 64px", 
    width: "100%", 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center",

    [PureLightTheme.breakpoints.down("md")]: {
        padding: "24px", 
    },
}

export const StepLabelStyle = {
    '& .MuiStepLabel-label': { 
        fontSize: '16px', 
        fontWeight: 600,
    }
}

export const BoxSpanStyle = {
    color: COLORS.CERULEAN, 
    fontWeight: 600,
}
